var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-demo"},[_c('h1',[_vm._v("这个是双画面播放器测试demo")]),_c('h1',[_vm._v("这个是双画面播放器测试demo")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.switchPictureCount}},[_vm._v("切换画面数量")]),_c('lw-two-screen-player',{attrs:{"player-id":'353',"picture-count":_vm.pictureCount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }